import * as React from "react";
import { Remove } from "../Remove";
import { Icon } from "sb-resp-ui";
export class Market extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-yourbet__market" },
            React.createElement("div", { className: "rj-yourbet__market-details" },
                React.createElement("p", { className: "rj-yourbet__market-title" }, this.props.title),
                React.createElement("p", { className: "rj-yourbet__market-type" }, this.props.market)),
            this.props.handler && React.createElement(Remove, { icon: "i-16 i-o-yourbet-trash", datauat: "i-o-trash", handler: this.props.handler }),
            this.props.isSuspended &&
                React.createElement("div", { className: "rj-yourbet__suspended-overlay", onClick: this.props.handler },
                    React.createElement("div", { className: "rj-yourbet__suspended-overlay-label" },
                        React.createElement(Icon, { i: "i-o-yourbet-close" }),
                        React.createElement("span", { className: "rj-yourbet__suspended-overlay-text" }, this.props.suspendedTxt)))));
    }
}
//# sourceMappingURL=Market.js.map